import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { BillingQueryParams, BillingResponse } from './billing.types';

const billingApiPath = 'billing';

export const getBilling = async ({
  params,
}: {
  params?: BillingQueryParams;
}): Promise<AxiosResponse<BillingResponse & ApiError>> => {
  return instance
    .get<BillingResponse>(billingApiPath, { params })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

const billingShortApiPath = 'billing-short';
export const getShortBilling = async ({
  params,
}: {
  params?: BillingQueryParams;
}): Promise<AxiosResponse<BillingResponse & ApiError>> => {
  return instance
    .get<BillingResponse>(billingShortApiPath, { params })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
